import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // cancelTokenArr: [] // 取消请求token数组

  },
  mutations: {
    // pushToken (state, payload) {
    //   state.cancelTokenArr.push(payload.cancelToken)
    // },
    // clearToken ({ cancelTokenArr }) {
    //   cancelTokenArr.forEach(item => {
    //     console.log(item)
    //     item('路由跳转取消请求')
    //   })
    //   cancelTokenArr = []
    // }

  },
  actions: {

  }
})

// var store = new vuex.Store({//store对象
//   state: {
//     states: 'turn-on'
//   },
//   mutations: {
//     setTransition(state, states) {
//       state.states = states
//     }
//   }
// })
